import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardLineeService from "./dashboardLineeService";
import { Form, InputGroup } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
import { Modal, Button, Row } from "react-bootstrap";
toast.configure();

class Linee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      linee: [
        {
          idLinea: 0,
          nomeLinea: "",
          idCliente: "",
          statobottne: true,
        },
      ],
      abilitazioneDiModificaSuUnLinea: [], //è un array di chiavi per abilitare e disabilitare un bottone di un area
      loading: true,
      abilitaModificaLinea: [],
      eliminaModal: false,
      idDaEliminare: 0,
      AggiungiUnaLinea: false,
      nomeLinea: "",
      loadingButton:false,
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    // this.onRowClick = this.onRowClick.bind(this);
  }

  componentDidMount() {
    this.dashboardLineeService = new DashboardLineeService();

    this.dashboardLineeService.getDataTableLenee((Linee) => {
      Linee.data.map((linee) => {
        linee.statobottne = true;
        linee.bottoniEditi = true;
      });
      this.setState({ linee: Linee.data });
    });
    this.setState({ loading: false });
  }

  onChangeNomelineea(event) {
    const idInput = event.target.id;
    this.state.linee[idInput].nomeLinea = event.target.value;
    this.setState({ linee: this.state.linee });
  }

  annullaElimina() {
    this.setState({ eliminaModal: false });
  }

  confremaElimna() {
    this.setState({loadingButton:true})
    this.dashboardLineeService.deleteLinea(
      this.state.idDaEliminare,
      (result) => {
        this.setState({loadingButton:false})
        if (result.status === 200) {
          toast.success("Eliminato con successo");
        } else {
          toast.error("Qualcosa è andato storto");
        }
        this.dashboardLineeService.getDataTableLenee((Linee) => {
          Linee.data.map((linee) => {
            linee.statobottne = true;
            linee.bottoniEditi = true;
          });
          this.setState({ linee: Linee.data, eliminaModal: false });
        });
      }
    );
  }

  eliminaModal() {
    return (
      <>
        <Modal size="sm" show={this.state.eliminaModal}>
          <Modal.Header>
            <Modal.Title>Elimina Linea</Modal.Title>
          </Modal.Header>
          <Modal.Body>Sei sicuro di eliminare la linea?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaElimina.bind(this)}
            >
              Annulla
            </Button>
            <Button variant="danger" disabled={this.state.loadingButton} onClick={this.confremaElimna.bind(this)}>
              {this.state.loadingButton ? <LoadSpinner/> : "Elimina Linea"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  annullaAggiungi() {
    this.setState({ AggiungiUnaLinea: false, nomeLinea: "" });
  }

  confremaAggiungi() {
    this.nuovaLinea = {
      nomeLinea: this.state.nomeLinea,
    };
    this.setState({loadingButton:true})
    this.dashboardLineeService.insertLinea(this.nuovaLinea, (result) => {
      this.setState({loadingButton:false})
      if (result.status === 200) {
        toast.success("Linea aggiunta con successo");
      } else {
        toast.error("Qualcosa è andato storto");
      }

      this.dashboardLineeService.getDataTableLenee((Linee) => {
        Linee.data.map((linee) => {
          linee.statobottne = true;
          linee.bottoniEditi = true;
        });
        this.setState({
          linee: Linee.data,
          AggiungiUnaLinea: false,
          nomeLinea: "",
        });
      });
    });
  }

  onChangeNuovaLinea(event) {
    this.state.nomeLinea = event.target.value;
    this.setState({ nomeLinea: this.state.nomeLinea });
  }

  AggiungiUnaLinea() {
    return (
      <>
        <Modal size="lg" show={this.state.AggiungiUnaLinea}>
          <Modal.Header>
            <Modal.Title>Aggiungi una nuova Linea</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Nome Linea</label>
            <input
              className="form-control"
              type="text"
              value={this.state.nomeLinea}
              onChange={this.onChangeNuovaLinea.bind(this)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaAggiungi.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.loadingButton || this.state.nomeLinea.length < 3}
              onClick={this.confremaAggiungi.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Aggiungi Linea"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  tabellaAree() {
    return (
      <>
        <table class="table table-bordered text-center">
          <thead>
            <tr>
              <th scope="col">Nome Linea</th>
              <th scope="col">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {this.state.linee.map((linee, index) => {
              return (
                <>
                  <tr>
                    <th>
                      <input
                        id={index}
                        disabled={linee.statobottne}
                        className="form-control"
                        type="text"
                        value={linee.nomeLinea}
                        onChange={this.onChangeNomelineea.bind(this)}
                      />
                    </th>
                    <td>
                      {linee.bottoniEditi ? (
                        <>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              this.dashboardLineeService.getDataTableLenee(
                                (Linee) => {
                                  Linee.data.map((linee, indeds) => {
                                    if (indeds === index) {
                                      linee.statobottne = false;
                                      linee.bottoniEditi = false;
                                    } else {
                                      linee.statobottne = true;
                                      linee.bottoniEditi = true;
                                    }
                                  });

                                  //   console.log(Linee);
                                  this.setState({ linee: Linee.data });
                                }
                              );
                              this.setState({ loading: false });
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-edit"></i>{" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              this.setState({
                                eliminaModal: true,
                                idDaEliminare: this.state.linee[index].idLinea,
                              })
                            }
                          >
                            {" "}
                            <i className="fas fa-fw fa-trash"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingButton}
                            onClick={() => {
                              //   console.log(this.state.linee[index]);

                              this.lineaEdit = {
                                idLinea: this.state.linee[index].idLinea,
                                nomeLinea: this.state.linee[index].nomeLinea,
                                idCliente: this.state.linee[index].idCliente,
                              };
                              this.setState({loadingButton:true})
                              this.dashboardLineeService.salvaModifica(
                                this.lineaEdit,
                                (result) => {
                                  this.setState({loadingButton:false})
                                  if (result.status === 200) {
                                    toast.success("Linea Aggiornata");
                                  } else {
                                    toast.error("Linea non Aggiornata");
                                  }
                                  this.dashboardLineeService.getDataTableLenee(
                                    (Linee) => {
                                      Linee.data.map((linee) => {
                                        linee.statobottne = true;
                                        linee.bottoniEditi = true;
                                      });
                                      this.setState({ linee: Linee.data });
                                    }
                                  );
                                }
                              );
                            }}
                          >
                            {" "}
                            {this.state.loadingButton ? <LoadSpinner/> : <i className="fas fa-fw fa-check"></i>}
                            {" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            id={index}
                            onClick={() => {
                              this.dashboardLineeService.getDataTableLenee(
                                (Linee) => {
                                  Linee.data.map((linee, indeds) => {
                                    if (indeds === index) {
                                      linee.statobottne = true;
                                      linee.bottoniEditi = true;
                                    } else {
                                      linee.statobottne = true;
                                      linee.bottoniEditi = true;
                                    }
                                  });
                                  this.setState({ linee: Linee.data });
                                }
                              );
                              this.setState({ loading: false });
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-times"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </>
    );
  }
  render() {
    // console.log(this.state.linee);
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Linee<br></br>
            </h1>
            {/* <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              > 
                Aree &#8594; In Lavorazione
              </small>< */}

            <button
              type="button"
              class="btn btn-warning"
              onClick={() => {
                this.setState({ AggiungiUnaLinea: true });
              }}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi
              una nuova Linea
            </button>
            <a className=""></a>
          </div>
          <br />
          <br />
          <div className="col">{this.tabellaAree()}</div>
          {this.eliminaModal()}
          {this.AggiungiUnaLinea()}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(Linee);
